import { render, staticRenderFns } from "./MySession.vue?vue&type=template&id=0b72ecba"
import script from "./MySession.vue?vue&type=script&lang=js"
export * from "./MySession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports